/**
 * Host-aware routing for HealthContours.
 *
 * On healthcontours.com the map (the public splash) is served at "/".
 * Elsewhere it stays at "/healthcontours" so it does not shadow CareMap / HealthDesk.
 */

import { HEALTHCONTOURS_AUDIENCE_SLUGS } from "./healthContoursAudienceData";

export function isHealthContoursHost() {
  if (typeof window === "undefined") return false;
  try {
    if (window.localStorage?.getItem("HEALTHCONTOURS_HOST") === "1") return true;
  } catch {
    // private mode
  }
  const host = window.location.hostname.toLowerCase();
  return host === "healthcontours.com" || host.endsWith(".healthcontours.com");
}

export function healthContoursMapPath() {
  return isHealthContoursHost() ? "/" : "/healthcontours";
}

/**
 * Path to an audience marketing page for a given slug (e.g. "for-patients").
 *
 * On healthcontours.com the pages live at clean roots (`/for-patients`).
 * Elsewhere they are prefixed (`/healthcontours/for-patients`) so they do not
 * shadow CareMap / HealthDesk routes — matching the signup / advertise pattern.
 *
 * @param {string} slug
 * @returns {string}
 */
export function healthContoursAudiencePath(slug) {
  if (!slug) return healthContoursMapPath();
  return isHealthContoursHost() ? `/${slug}` : `/healthcontours/${slug}`;
}

/**
 * True when the path is a HealthContours surface on any host
 * (map, signup, advertise, audience pages).
 */
export function isHealthContoursPath(pathname = "") {
  if (typeof pathname !== "string") return false;
  const normalized = pathname.replace(/\/+$/, "") || "/";
  if (
    normalized === "/healthcontours" ||
    normalized.startsWith("/healthcontours/")
  ) {
    return true;
  }
  if (!isHealthContoursHost()) return false;
  if (normalized === "/") return true;
  const segment = normalized.replace(/^\/+/, "").split("/")[0];
  return HEALTHCONTOURS_AUDIENCE_SLUGS.includes(segment);
}
